import React, { Component } from "react";
import { Modal, Table } from "antd";

const columns = [{
	title: "Type",
	dataIndex: "description",
	key: "description",
}, {
	title: "Old",
	dataIndex: "old",
	key: "old",
}, {
	title: "New",
	dataIndex: "attributes",
	key: "attributes",
},
{
	title: "Date/Time",
	dataIndex: "created",
	key: "created",
}
];


class EmptyModal extends Component {
    state = {
    	visible: false,
    	user: null,
    };  
    showModal = (user) => {
    	if (user) {
    		this.setState({ visible: true, user  });
    	}
    };
  handleOk = e => {
  	this.setState({
  		visible: false
  	});
  };
  handleCancel = e => {
  	this.setState({
  		visible: false
  	});
  };
  render() {
  	const { children, title = "", width = 800 } = this.props;
  	const  { user }  = this.state;
  	if (user) {
  		const history = user.user.history.data;
  		// console.log(history);
  		console.log(this.props.choice);
  		return (
  			<div>
  				<Modal
  					title={title}
  					visible={this.state.visible}
  					onOk={this.handleOk}
  					onCancel={this.handleCancel}
  					footer={null}
  				>
  					{/* <Table dataSource={history} columns={columns} />           */}
  				</Modal>
  			</div>
  		);
  	} else return "";
  }
}

export default EmptyModal;



// WEBPACK FOOTER //
// ./src/components/modal/SeeHistoryEmployees.js